export const CustomerReferenceTypes = [
  { key: 'CR', value: 'Customer Reference(CR)' },
  { key: 'EQ', value: 'Equipment(EQ)' },
  { key: 'P8', value: 'Pickup Number(P8)' },
  { key: 'PO', value: 'Purchase Order(PO)' },
  { key: 'RA', value: 'Return Acceptance(RA)' },
  { key: 'TR', value: 'Trailer Reference(TR)' },
  { key: 'AO', value: 'Appointment Number(AO)' },
  { key: 'SO', value: 'Shipper’s Order(SO)' },
  { key: 'BM', value: 'Bill of Lading(BM)' },
  { key: 'DC', value: 'Dealer Code (DC)' },
  { key: 'VN', value: 'VIN Number (VN)' },
  { key: 'RO', value: 'RO Number (RO)' },
  { key: 'PT', value: 'Part Number (PT)' }
];
